import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { useAuthStore } from '@/store';

const CHAT_HTTP_URL =
  (import.meta.env.VITE_CHAT_SERVICE_URL as string) || 'https://staging-chat.sloxt.com/chat';

const chatHttpLink = new HttpLink({
  uri: CHAT_HTTP_URL,
  fetch: (uri, options) => {
    const accessToken = useAuthStore.getState().accessToken;
    const headers = new Headers(options?.headers);
    if (accessToken) {
      headers.set('authorization', `Bearer ${accessToken}`);
    }
    return fetch(uri, { ...options, headers });
  },
});

export const chatClient = new ApolloClient({
  link: chatHttpLink,
  cache: new InMemoryCache(),
});

export const CHAT_WS_URL =
  (import.meta.env.VITE_CHAT_WS_URL as string) ||
  'wss://wx3z1az0b4.execute-api.us-east-1.amazonaws.com/staging';
